import React, { forwardRef } from 'react'
import MuiButton, { ButtonProps } from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import styles, { NEW_DESIGN_OVERRIDES } from './styles'

export type ButtonPropsType = {
  component?: string
  size?: 'small'
  design?: 'primary' | 'secondary' | 'text' | 'delete'
} & ButtonProps

export const Button = forwardRef<HTMLButtonElement, ButtonPropsType>(
  function Button(props, ref) {
    return <MuiButton ref={ref} {...props} />
  }
)

export default withCommonSnapshotsOnly(
  withStyles(styles(), { name: 'MuiButton' })(Button)
)

const _ButtonNew = forwardRef<HTMLButtonElement, ButtonPropsType>(
  function _ButtonNew(props, ref) {
    // defaults to contained, but allows override to outlined
    const { design, variant = 'contained' } = props
    const overrideProps: ButtonPropsType = {}

    switch (design) {
      case 'primary':
        overrideProps.variant = variant
        overrideProps.color = 'primary'
        break
      case 'secondary':
        overrideProps.variant = variant
        overrideProps.color = 'secondary'
        break
      case 'delete':
        overrideProps.variant = variant
        overrideProps.className = 'error'
        break
      case 'text':
      default:
        overrideProps.color = 'primary'
        break
    }
    return (
      <MuiButton
        ref={ref}
        {...overrideProps}
        {...props}
        className={props.className || '' + ' ' + overrideProps.className || ''}
      />
    )
  }
)

export const ButtonNew = withCommonSnapshotsOnly(
  withStyles(
    styles(() => NEW_DESIGN_OVERRIDES),
    { name: 'MuiButtonNew' }
  )(_ButtonNew)
)
